import { NavLink } from 'react-router-dom'
import { House, CoatHanger, Sparkle, MagicWand, Gear, UserCircle, Info } from '@phosphor-icons/react'
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet'
import { cn } from '@/lib/utils'

interface AppDrawerProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function AppDrawer({ open, onOpenChange }: AppDrawerProps) {
  const navigationItems = [
    { to: '/', label: 'Home', icon: House },
    { to: '/closet', label: 'Closet', icon: CoatHanger },
    { to: '/try-on', label: 'Try-On', icon: Sparkle },
    { to: '/stylist', label: 'Stylist', icon: MagicWand },
  ]

  const secondaryItems = [
    { to: '/profile', label: 'Profile', icon: UserCircle },
    { to: '/settings', label: 'Settings', icon: Gear },
    { to: '/about', label: 'About', icon: Info },
  ]

  const handleNavClick = () => {
    onOpenChange(false)
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader className="border-b border-gray-200">
          <SheetTitle className="text-gray-900">Cufflink</SheetTitle>
        </SheetHeader>

        <nav className="flex-1 overflow-y-auto py-6">
          <div className="space-y-1 px-3">
            <div className="mb-6">
              <p className="px-3 text-xs font-bold text-gray-600 uppercase tracking-wider mb-3">
                Main
              </p>
              {navigationItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={handleNavClick}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 rounded-full px-4 py-3 text-sm font-semibold transition-all duration-200',
                      isActive
                        ? 'bg-gray-900 text-white shadow-sm'
                        : 'text-gray-700 hover:bg-gray-100 active:bg-gray-200'
                    )
                  }
                >
                  <item.icon size={20} weight="regular" />
                  {item.label}
                </NavLink>
              ))}
            </div>

            <div className="pt-6 border-t border-gray-200">
              <p className="px-3 text-xs font-bold text-gray-600 uppercase tracking-wider mb-3">
                Other
              </p>
              {secondaryItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={handleNavClick}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 rounded-full px-4 py-3 text-sm font-semibold transition-all duration-200',
                      isActive
                        ? 'bg-gray-900 text-white shadow-sm'
                        : 'text-gray-700 hover:bg-gray-100 active:bg-gray-200'
                    )
                  }
                >
                  <item.icon size={20} weight="regular" />
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
        </nav>

        <div className="border-t border-gray-200 p-4">
          <p className="text-xs text-gray-500 text-center font-medium">
            Version 0.1.0
          </p>
        </div>
      </SheetContent>
    </Sheet>
  )
}
